const TimesheetsPage = () => (
  <div>TImesheets</div>
);

export default TimesheetsPage;
